import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-count-down-timer',
  templateUrl: './count-down-timer.component.html',
  styleUrls: ['./count-down-timer.component.scss']
})
export class CountDownTimerComponent implements OnInit {
  @Output() onCounterEnd: EventEmitter<any> = new EventEmitter();
  @Input() initialTime: number = 1; // in minutes

  remainingTime: number = 0;
  timerInterval: any;
  displayTime: string = '00:00';

  ngOnInit(): void {
    this.startTimer();
  }

  startTimer(minutes: number = this.initialTime): void {
    this.stopTimer(); // Stop any existing interval
    this.remainingTime = minutes * 60;
    this.updateTimerDisplay();

    this.timerInterval = setInterval(() => {
      this.remainingTime--;
      this.updateTimerDisplay();

      if (this.remainingTime <= 0) {
        this.stopTimer();
        this.onTimerEnd();
      }
    }, 1000);
  }

  stopTimer(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  resetTimer(): void {
    this.stopTimer();
    this.remainingTime = this.initialTime * 60;
    this.updateTimerDisplay();
  }

  restart(): void {
    this.startTimer();
  }

  updateTimerDisplay(): void {
    const minutes = Math.floor(this.remainingTime / 60);
    const seconds = this.remainingTime % 60;
    this.displayTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  onTimerEnd(): void {
    this.onCounterEnd.emit(true);
  }
}
